module.exports = __webpack_public_path__ + "static/media/rekrytering.17722e57.jpg";